define([
	"dojo/_base/declare",
	"csi/heading/StringSelection",
	"csi/html",
	"csi/state/rootStore",
	"csi/locale",
	"csi/store/Locales",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Search"
], function(declare, StringSelection, html, {sessionStore}, locale, Locales, Names, xml, Search) {

	return declare(StringSelection, {
		bCopy: true,

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: convert value to displayed value based on format; there is one special case
			// for Node Type attribute where attribute id is needed
			return locale.resource(value);
		},

		fromHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*FilteringSelect*/editNode) {
			// summary: return attribute value from edit control
			return editNode.get("value");
		},

		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			// summary: return store of available locales
			let companyDefaultLocale = null;
			const nodeType = ctx.getNodeType();
			if (nodeType == "UserDetails") {
				if (!xml.isValidURL(ctx.getNode()["Node Crew"])) {
					companyDefaultLocale = sessionStore.siteLocale;
				} else {
					const companyInfoNode = ctx.cache.getPathNode(ctx.getNode(),"Child:Node Crew/Child:CompanyInfo");
					companyDefaultLocale = companyInfoNode ? companyInfoNode.DefaultLocale : null;
				}
			}
			return companyDefaultLocale ? this.getLocaleStoreWithPriority(companyDefaultLocale) : Locales;
		},

		toTooltipEdit: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			// summary: return DOMNode to display as tooltip while editing
			if (h.m_tooltip) {
				return html.create("div", {
					innerText: h.m_tooltip
				});
			}

			return this.inherited(arguments);
		},

		/**
		 * Get the Locale Store based on the company default locale
		 * @param {String} defaultLocale
		 * @return {store}
		 */
		getLocaleStoreWithPriority: function(defaultLocale) {
			let search = new Search({Operation: "NamesByXML"}).byType("Locale");
			search.getQuery().Attr("Active", xml.OP_EQUALS, true, "Child:SetupSettings")
							.Attr("Node Name", xml.OP_EQUALS, defaultLocale);

			const priorityStore = new Names({
				request: search.getRequest(),
				onResultItem: function(item, namesInst) {
					const {idProperty,labelProperty} = namesInst;
					item[idProperty] = item.Name;
					item[labelProperty] = locale.resource(item.Name);
				}
			});

			search = new Search({Operation: "NamesByXML"}).byType("Locale");
			search.getQuery().Attr("Active", xml.OP_EQUALS, true, "Child:SetupSettings");

			return new Names({
				onResultItem: function(item, namesInst) {
					const {idProperty,labelProperty} = namesInst;
					item[idProperty] = item.Name;
					item[labelProperty] = locale.resource(item.Name);
				},
				priorityStore: priorityStore,
				treatAsPriority: true,
				request: search.getRequest()
			});
		}
	});
});